/* eslint-disable camelcase */
import { useOAIQuery } from '~/hooks/reactQuery';

const isValidBusinessId = (businessId: string) => {
  return !Number.isNaN(Number(businessId));
};

// 기본 redirect template (market_home_redirect용)
export type RedirectTemplate = {
  redirectUrl: string;
  endDate?: string;
  result?: string;
};

// 제네릭 Creative 타입
export type Creative<T> = {
  ad_group_id: number;
  creative_id: number;
  template: T;
  creative_template_id: number;
  priority: number;
};

// 제네릭 Placement 타입
type Placement<T> = {
  name: string;
  meta: Record<string, unknown>;
  render_type: string;
  render_meta: Record<string, unknown>;
  priority: number;
  creatives: Creative<T>[];
};

// 제네릭 Response 타입
export type PlacementRawResponse<T> = {
  placements: Placement<T>[];
};

// eslint-disable-next-line @typescript-eslint/ban-types
export const usePlacementRaw = <T = {}>(
  businessId: string,
  mmpCode: string,
  uuid?: string,
) => {
  const { data: rawData, ...rest } = useOAIQuery({
    queryKey: '/api/market-place/v1/placements/raw',
    queryOptions: {
      enabled: isValidBusinessId(businessId) && !!mmpCode,
      keepPreviousData: true,
    },
    variables: {
      businessId: Number(businessId),
      mmpCode,
      uuid,
    },
  });

  const data = rawData
    ? (JSON.parse(rawData) as PlacementRawResponse<T>)
    : null;

  return { data, ...rest };
};
